export default "__VITE_ASSET__58662f76__"